// AddEventListeners for qty don't seem to be working..
// Estimated Total is not correct either.

class RepairCart {
  constructor(serviceCart) {
    this.serviceCart = serviceCart;
  }

  get estimateTotal() {
    return this.calcEstimate();
  }

  get weight() {
    return this.calcWeight();
  }

  get totalQty() {
    return this.calcTotalQuantity();
  }

  calcEstimate() {
    let total = 0;
    for (let editID in this.discountedCart) {
      const { lineItemPrice } = this.discountedCart[editID];
      total += parseFloat(lineItemPrice);
    }
    return total;
  }

  calcLineItemCost(editID, qty) {
    let totalCost = 0;
    for(let variantId in this.discountedCart[editID].variantList) {
      const { cost } = this.discountedCart[editID].variantList[variantId]
      totalCost += parseFloat(cost)
    }
    return (totalCost * qty);
  }

  calcWeight() {
    let totalWeight = 0;
    for (let editID in this.discountedCart) {
      if (editID !== "checkoutData") {
        const { weight, quantity } = this.discountedCart[editID];
        totalWeight += Math.round(parseFloat(parseFloat(weight) * parseFloat(quantity)));
      }
    }
    return totalWeight;
  }

  calcTotalQuantity() {
    let qty = 0;
    for (let editID in this.discountedCart) {
      const { quantity } = this.discountedCart[editID];
      qty += quantity;
    }
    return qty;
  }

  get arrayVariantList() {
    // Return an array of all the variant ids in the cart.
    const variantArray = [];
    for (let editID in this.discountedCart) {
      console.log(`arrayVariantList: ${editID}`);
      if (editID !== "checkoutData") {
        for (const variant in this.discountedCart[editID]["variantList"]) {
          variantArray.push(parseInt(variant));
        }
      }
    }
    return variantArray;
  }

  get arrayProductIdList() {
    // Return an array of all the product ids in the cart.
    const productIdArray = [];
    for (const editID in this.discountedCart) {
      if (editID !== "checkoutData") {
        const { quantity } = this.discountedCart[editID];
        productIdArray.push([this.discountedCart[editID]["productId"], quantity]);
      }
    }
    return productIdArray;
  }
}
